import type { RootState } from './reducer';

export const secondArg = <T>(_: RootState, second: T) => second;
export const thirdArg = <T>(_: RootState, __: unknown, third: T) => third;
export const optionalThirdArg = <T>(_: RootState, __: unknown, third?: T) => third;
